import {AfterViewChecked, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ModalComponent} from "../../../../utils/modal/modal.component";
import {TranslateService} from "@ngx-translate/core";

declare var bootstrap: any;

const correctAnswersCallanMethod: {[key: number]: string} = {
  1: 'A2',
  2: 'A1',
  3: 'A1',
  4: 'A1',
  5: 'A2',
  6: 'A2',
  7: 'A1'
}

const correctAnswersLevelTest: {[key: number]: string} = {
  1: 'A3',
  2: 'A2',
  3: 'A2',
  4: 'A3',
  5: 'A1',
  6: 'A2'
}

@Component({
  selector: 'app-pre-prova-quiz',
  templateUrl: './pre-prova-quiz.component.html',
  styleUrl: './pre-prova-quiz.component.scss',
  standalone: false
})

export class PreProvaQuizComponent implements OnInit, AfterViewChecked {

  @ViewChild('preProvaQuizModal', { static: true }) preProvaQuizModal: ModalComponent;
  @ViewChild('resultModal', { static: true }) resultModal: ModalComponent;

  @Input() quizName: string
  questions: { question: string; answers: { key: string; text: string }[] }[] = [];
  selectedAnswers: { [key: number]: string } = {};
  correctAnswers: { [key: number]: string } = {};
  translations: any

  resultKey = '';
  score: number

  tooltipReady = false

  constructor(private translateService: TranslateService,
              private elRef: ElementRef ) {}

  ngOnInit() {
    const quizPath = `COL.LESSONS.DETAILS.QUIZ.${this.quizName}`
    this.translateService.get(quizPath).subscribe(
      (value) => {
        this.translations = value
        this.buildQuiz()
      }
    )
  }

  ngAfterViewChecked() {
    let tooltipInstances = [];
    if (!this.tooltipReady) {
      const tooltips = this.elRef.nativeElement.querySelectorAll('[data-bs-toggle="tooltip"]');
      tooltips.forEach((el: HTMLElement) => {
        if (el?.getAttribute('title'))
          tooltipInstances.push(new bootstrap.Tooltip(el));
      });
      if(tooltipInstances.length == tooltips.length)
        this.tooltipReady = true;
    }
  }

  open() {
    this.preProvaQuizModal.show()
  }

  buildQuiz() {
    switch (this.quizName) {
      case "CALLAN_METHOD":
        this.correctAnswers = correctAnswersCallanMethod
        break;

      case "LEVEL_TEST":
        this.correctAnswers = correctAnswersLevelTest
        break;
    }

    this.questions = []

    for(const key of Object.keys(this.translations)) {
      if (key.startsWith('QUESTION_')) {
        const qData = this.translations[key];
        const answers = Object.keys(qData)
          .filter((k) => k.startsWith('A'))
          .map((k) => ({ key: k, text: qData[k] }));

        this.questions.push({
          question: qData.Q,
          answers,
        });
      }
    }
  }

  checkAnswers(){
    let correctCount = 0;
    this.questions.forEach((_, i) => {
      const qNum = i + 1;
      if (this.selectedAnswers[qNum] === this.correctAnswers[qNum]) {
        correctCount++;
      }
    });
    this.score = correctCount;

    const resultPath = `COL.LESSONS.DETAILS.QUIZ.${this.quizName}.RESULT`;

    if (correctCount === this.questions.length) this.resultKey = `${resultPath}.FULL`;
    else if (correctCount >= this.questions.length * 0.6) this.resultKey = `${resultPath}.MID`;
    else this.resultKey = `${resultPath}.LOW`;

    this.preProvaQuizModal.hide()
    this.resultModal.show()
  }

  allAnswered(): boolean {
    return this.questions.length > 0 &&
      this.questions.every((_, i) => !!this.selectedAnswers[i + 1]);
  }
}
